import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Card: any = styled.section`
  display: flex;
  min-height: 135px;
  padding: 8px 14px;
  border-radius: 8px;
  flex-direction: column;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.flightDetails.price.boxShadow};
  background: ${ColorPalette.HEX.White};
`;

Card.Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

Card.Section = styled.div`
  flex: 1;
  display: flex;
  margin: 8px 0;
  flex-direction: column;
  justify-content: center;
`;

Card.Label = styled.span`
  font-size: 12px;
  line-height: 1.33;
  font-style: normal;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.flightDetails.price.label};
`;

Card.Value = styled.span`
  font-size: 12px;
  line-height: 1.14;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.flightDetails.price.priceValue};
`;

Card.Total = styled.span`
  font-size: 14px;
  line-height: 1.14;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.flightDetails.price.priceValue};
`;

Card.TotalLabel = styled.span`
  font-size: 14px;
  margin-top: 12px;
  line-height: 1.33;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.flightDetails.price.label};
`;

Card.Title = styled.h4`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.71;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.flightDetails.price.title};
`;

export const Division = styled.hr`
  height: 1px;
  border: 0 none;
  color: ${({ theme }) => theme.flightDetails.price.division};
  background-color: ${({ theme }) => theme.flightDetails.price.division};
`;
